// Behaviors specific to the registrations form:
// 1. Semester segmented picker + year select reload the page so the controller
//    can rebuild the list of available courses for the chosen semester/year.
// 2. "Lista de espera" chip toggles a hidden boolean field per course row.

document.addEventListener("DOMContentLoaded", () => {
  const root = document.querySelector("[data-registration-form]")
  if (!root) return

  const baseUrl = root.dataset.reloadUrl
  const yearSelect = root.querySelector("[data-year-select]")
  const semesterButtons = root.querySelectorAll("[data-semester-button]")
  const semesterInput = root.querySelector("[data-semester-input]")

  const reload = (semester, year) => {
    if (!baseUrl || !semester || !year) return
    window.location.href = `${baseUrl}/${semester}/${year}`
  }

  semesterButtons.forEach((button) => {
    button.addEventListener("click", (event) => {
      event.preventDefault()
      const next = button.dataset.semesterButton
      if (semesterInput && semesterInput.value === next) return
      reload(next, yearSelect?.value)
    })
  })

  if (yearSelect) {
    yearSelect.addEventListener("change", () => {
      reload(semesterInput?.value, yearSelect.value)
    })
  }

  // Chip toggle (lista de espera). Event-delegated so it works for rows added
  // dynamically by nested_form.js.
  root.addEventListener("click", (event) => {
    const chip = event.target.closest("[data-chip-toggle]")
    if (!chip || !root.contains(chip)) return
    event.preventDefault()
    const item = chip.closest("[data-nested-form-item]") || root
    const input = item.querySelector(`input[data-chip-input='${chip.dataset.chipToggle}']`)
    if (!input) return
    const isOn = input.value === "1"
    const next = !isOn
    input.value = next ? "1" : "0"
    chip.setAttribute("aria-pressed", String(next))
    if (chip.dataset.chipToggle === "on_waiting_list" && item.dataset) {
      item.dataset.waiting = String(next)
    }
    const label = chip.querySelector("[data-chip-label]")
    if (label) label.textContent = next ? chip.dataset.labelOn : chip.dataset.labelOff
  })
})
